'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var showNotification = exports.showNotification = function showNotification(config) {
  return {
    type: 'SHOW_NOTIFICATION',
    payload: config
  };
};

var hideNotification = exports.hideNotification = function hideNotification(direction) {
  return {
    type: 'HIDE_NOTIFICATION',
    payload: direction || 'default'
  };
};

var removeNotification = exports.removeNotification = function removeNotification() {
  return {
    type: 'REMOVE_NOTIFICATION'
  };
};

exports.default = {
  showNotification: showNotification,
  hideNotification: hideNotification,
  removeNotification: removeNotification
};